import { Link } from 'react-router-dom';

const footerLinks = {
  category: { title: '产品分类', links: [
    { to: '/category/meirong-hufu', label: '美妆护肤' },
    { to: '/category/jiaju-shenghuo', label: '家居生活' },
    { to: '/category/shuma-keji', label: '数码科技' },
    { to: '/category/fushi-peishi', label: '服饰配饰' },
    { to: '/category/meishi-yinpin', label: '美食饮品' },
    { to: '/category/muying-yongpin', label: '母婴用品' },
  ]},
  about: { title: '关于我们', links: [
    { to: '/about', label: '品牌介绍' },
    { to: '/about', label: '品质承诺' },
    { to: '/about', label: '联系我们' },
  ]},
  help: { title: '帮助中心', links: [
    { to: '/about', label: '常见问题' },
    { to: '/about', label: '退换政策' },
    { to: '/about', label: '隐私条款' },
  ]},
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
              国产精品
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              严选品质国货好物，让每一件国产精品都成为您生活品质的见证。
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-background-100/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-background-100/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-background-100/20 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-background-200"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2025 国产精品精选推荐 版权所有
          </p>
          <p className="text-xs text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">京ICP备XXXXXXXX号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
          </p>
        </div>
      </div>
    </footer>
  );
}